export enum PropertyType {
    FloatField = 'FloatField',
    SwitchField = 'SwitchField',
    BooleanField = 'BooleanField',
    GroupField = 'GroupField',
    CharField = 'CharField',
    ColorField = 'ColorField',
    IntegerField = 'IntegerField',
    ToggleField = 'ToggleField',
    TextField = 'TextField',
    GeometryField = 'GeometryField',
    PointArrayField = 'PointArrayField',
    Point = 'Point',
    ClassificationField = 'ClassificationField',
    ExpressionField = 'ExpressionField',
    ArrayField = 'ArrayField',
    Object = 'Object',
}

export declare type PropertyTypeString = keyof typeof PropertyType;

export interface Property {
    /** Field identifier */
    field: string;
    /** Field label (translatable) */
    label: string;
    value: any;
    /** Field type */
    type: PropertyTypeString;
    /** Properties children (for groups) */
    children: Property[] | undefined;
    /** Unit conversion function */
    convertUnit: any | undefined;
    /** Number of decimals */
    decimals: number | undefined;
    /** Function indicating if the field is editable*/
    editable: any | undefined;
    /** Indicates if the group is expanded */
    expanded: boolean | undefined;
    /** Function that get unit*/
    getUnit: any | undefined;
    /** Function*/
    isDirty: any | undefined;
    logarithmic: boolean | undefined;
    multiple: boolean | undefined;
    sortIndex: number | undefined;
    translate: boolean | undefined;
    unitType: any | undefined;
    /** Range of values or possible values*/
    valueRange: Array<number | string> | string | undefined;
    /** Function that indicates if is visible*/
    visible: any | undefined;
    selected?: number;

    mandatory: any | undefined;
    order: number | undefined;
}
